import { useTranslation } from "react-i18next";
import BaseLayout from "../layout/BaseLayout";

interface MaintenanceOverlayProps {
  message: string | null;
}

export default function MaintenanceOverlay({ message }: MaintenanceOverlayProps) {
  const { t } = useTranslation();
  const displayMessage = message?.trim() || t("maintenance.pageMessage");

  return (
    <BaseLayout>
      <div className="min-h-[calc(100vh-3.5rem)] flex flex-col items-center justify-center bg-white px-4">
        <div className="w-16 h-16 flex items-center justify-center mb-6 rounded-full bg-gray-100">
          <i className="ri-tools-line text-2xl text-gray-500"></i>
        </div>
        <h1 className="text-xl font-semibold text-gray-900 mb-2">{t("maintenance.pageTitle")}</h1>
        <p className="max-w-lg whitespace-pre-line text-center text-sm leading-6 text-gray-500">
          {displayMessage}
        </p>
      </div>
    </BaseLayout>
  );
}
